import _jsx from "@babel/runtime/helpers/jsx";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import React from 'react';
import { defineMessages } from 'react-intl';
import _ from 'lodash';
import ContextProvider from '../../components/ContextProvider/ContextProvider';
import OnlineProvider from '../../components/OnlineProvider/OnlineProvider';
import notAuthorized from '../not-authorized';
import LessonDetails from './LessonDetails';
import { getLessonBySlug, resetTextNotes, resetVideoNotes } from '../../actions/lessonDetails';
import { reset } from '../../actions/courseDetails';
import { getTranscodingJobs } from '../../actions/transcodingJobs';
import { isIOS, isIOSServer, ssrRequest } from '../../helpers';
import isLoggedIn from '../../helpers/checkAuth';
var messages = defineMessages({
  lessonTitle: {
    id: "LessonDetails.lessonTitle",
    defaultMessage: [{
      "type": 0,
      "value": "lesson"
    }]
  }
});
function action(_x) {
  return _action.apply(this, arguments);
}
function _action() {
  _action = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(context) {
    var _this = this;
    var store, params, fetch, query, formatMessage, cloudfrontUrl, userAgent, lessonSlug, _store$getState, auth, promises, requests, notAuthorizedReq, notFoundReq, _store$getState2, lessonDetails, title, imageUrl;
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          store = context.store, params = context.params, fetch = context.fetch, query = context.query, formatMessage = context.intl.formatMessage, cloudfrontUrl = context.cloudfrontUrl, userAgent = context.userAgent;
          lessonSlug = params.lessonSlug;
          _store$getState = store.getState(), auth = _store$getState.auth;
          _context3.next = 5;
          return store.dispatch(reset());
        case 5:
          _context3.next = 7;
          return store.dispatch(resetTextNotes());
        case 7:
          _context3.next = 9;
          return store.dispatch(resetVideoNotes());
        case 9:
          promises = [];
          promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) switch (_context.prev = _context.next) {
                case 0:
                  return _context.abrupt("return", ssrRequest({
                    getAction: getLessonBySlug.bind(_this, lessonSlug),
                    store: store,
                    fetch: fetch,
                    context: context
                  }));
                case 1:
                case "end":
                  return _context.stop();
              }
            }, _callee);
          })));
          if (isLoggedIn(auth)) {
            promises.push( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
              return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                while (1) switch (_context2.prev = _context2.next) {
                  case 0:
                    return _context2.abrupt("return", ssrRequest({
                      getAction: getTranscodingJobs.bind(_this, {
                        page: 1,
                        perPage: 10,
                        lessonId: lessonSlug,
                        'status[0]': 'pending',
                        'status[1]': 'processing'
                      }),
                      store: store,
                      fetch: fetch,
                      context: context
                    }));
                  case 1:
                  case "end":
                    return _context2.stop();
                }
              }, _callee2);
            })));
          }
          _context3.next = 14;
          return Promise.all(promises.map(function (promise) {
            return promise();
          }));
        case 14:
          requests = _context3.sent;
          notAuthorizedReq = _.find(requests, function (item) {
            return _.get(item, 'status') === 401;
          });
          notFoundReq = _.find(requests, function (item) {
            return _.get(item, 'status') >= 400;
          });
          if (!notAuthorizedReq) {
            _context3.next = 19;
            break;
          }
          return _context3.abrupt("return", notAuthorized(context));
        case 19:
          if (!notFoundReq) {
            _context3.next = 21;
            break;
          }
          return _context3.abrupt("return", notFoundReq);
        case 21:
          _store$getState2 = store.getState(), lessonDetails = _store$getState2.lessonDetails;
          title = "".concat(_.get(lessonDetails, 'lesson.name', ''), " - ").concat(formatMessage(messages.lessonTitle));
          imageUrl = _.get(lessonDetails, 'lesson.preview.path');
          if (imageUrl) {
            imageUrl = "".concat(cloudfrontUrl, "/").concat(imageUrl);
          }
          return _context3.abrupt("return", {
            chunks: ['lesson-details'],
            title: title,
            component: /*#__PURE__*/_jsx(ContextProvider, {
              context: context
            }, void 0, /*#__PURE__*/_jsx(OnlineProvider, {
              path: context.path
            }, void 0, /*#__PURE__*/_jsx(LessonDetails, {
              data: {},
              title: title,
              query: query,
              isIOS: isIOSServer(userAgent) || isIOS(),
              searchSessionId: query.searchSessionId
            })))
          });
        case 26:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _action.apply(this, arguments);
}
export default action;